import { render, staticRenderFns } from "./add-token.vue?vue&type=template&id=14f87a68"
import script from "./add-token.vue?vue&type=script&lang=js"
export * from "./add-token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports